import React, {useCallback, useRef} from "react";
import * as Yup from "yup";
import ValidateMessages from "../../../../core/models/static/texts/vallidate-messages";
import {makeRequired, makeValidate} from "mui-rff";
import {createUUId} from "../../../../core/services/utils/utils";
import useIsMounted from "../../../hooks/use-is-mounted";
import {Col} from "reactstrap";
import Form from "../../base/form";
import {OutlinedInputForm} from "../../base/input/outlined_input";
import Button from "../../base/button/button";
import Api from "../../../../core/services/api/api";


const schema = Yup.object().shape({
    code: Yup.string().trim().nullable().required(ValidateMessages.required),
});


const validate = makeValidate(schema);
const required = makeRequired(schema);


const ConnectToPrinterHub = ({
                                 onConnect,
                                 withButton = false,
                                 formId,
                                 submitting: submittingProps,
                                 setSubmitting,
                             }) => {
    const formIdRef = useRef(formId ?? createUUId());
    const isMounted = useIsMounted();

    /**
     * Connect to printer hub.
     *
     * @param values    {object}    Form values
     * @type {(function(*): Promise<void>)}
     */
    const connectPrinterHub = useCallback(async (values) => {
        if (setSubmitting) {
            setSubmitting(true);
        }
        const forApi = {
            code: values.code,
        }
        const response = await Api.connectPrinterHub(forApi);
        if (!isMounted())
            return;
        if (setSubmitting) {
            setSubmitting(false);
        }
        if (response?.resultFlag) {
            const printerHub = (await Api.getPrinterHubs())?.data?.find(e => e.id === response.data.partnerHubId);
            if (printerHub)
                onConnect(printerHub);
        }
    }, [isMounted, onConnect, setSubmitting])

    return (
        <>
            <div className={'d-flex flex-column w-100'}>
                <Col xs={12}>
                    <p className={'text-sm mb-3'}>
                        Enter the printer hub's code to connect to it.
                    </p>
                </Col>
                <Col xs={12} className={''}>
                    <Form
                        className='d-flex flex-wrap w-100 align-items-start'
                        onSubmit={connectPrinterHub}
                        id={formIdRef.current}
                        validate={validate}
                        initialValues={{}}
                        render={({values, form, submitting}) => {
                            return (
                                <>
                                    <Col xs={12} className={'p-0 mb-3'}>
                                        <OutlinedInputForm
                                            fullWidth
                                            name={'code'}
                                            placeholder={'code...'}
                                            label={"Code"}
                                            required={required.code}
                                            value={values.code ?? ''}
                                            onChange={(e) => form.change(e.target.name, e.target.value)}
                                        />
                                    </Col>
                                    {
                                        withButton &&
                                        <Col xs={12} className={'p-0 mb-3 d-flex justify-content-center'}>
                                            <Button
                                                disabled={submitting || submittingProps}
                                                variant={'contained'}
                                                color={'primary'}
                                                type={'submit'}
                                            >
                                                {
                                                    submitting || submittingProps
                                                        ? "Connecting"
                                                        : "Connect..."
                                                }
                                            </Button>
                                        </Col>
                                    }
                                </>
                            )
                        }}
                    />
                </Col>
            </div>
        </>
    );
}

export default ConnectToPrinterHub;
